import React, {memo, useCallback, useEffect, useState} from 'react';
import './index.scss';
import noVideo from '../../assets/images/no-image.png';
import {useInterval} from '../../hooks/interval';
import {Configs} from '../../configs';
type Props =
    { interval?: number; disableErrorHandling?: boolean; disablePrefix?: boolean; }
    & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const Video = memo(function Video(props: Props) {
    const {src: source, disableErrorHandling, disablePrefix, interval: rawInterval} = props;
    const [hasError, setHasError] = useState(false);
    const [interval, setInterval] = useState(rawInterval);
    const [src, setSrc] = useState(source);
    const [randomValue, setRandomValue] = useState(0);

    useInterval(useCallback(() => setRandomValue(Math.random()), []), interval);

    const onError = useCallback(() => {
        if (hasError || disableErrorHandling) {
            return;
        }
        setInterval(null);
        setHasError(true);
        setSrc(noVideo);
    }, [hasError, disableErrorHandling]);

    useEffect(() => {
        if (hasError) {
            return;
        }
        setInterval(rawInterval);
    }, [hasError, rawInterval]);

    useEffect(() => {
        setHasError(false);
        setSrc(source);
    }, [source]);

    return (
        <video src={(disablePrefix ? '' : Configs.IMAGE_PREFIX) + src + (randomValue ? '?rand=' + randomValue : '')}
                autoPlay={true}
                muted={true}
                onError={onError}/>
    );
});
